<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import type { Distributor } from "@shared/types/Distributor";

  export let distributors: Distributor[];

</script>

<div
  class="padding-left--default padding-right--default padding-bottom--smaller margin-top--small show--md"
>
  <div class="grid-row">
    <div class="grid-col c6-12">
      <div class="secondary-small--bold">Distributor</div>
    </div>
    <div class="grid-col c6-12 align-right">
      <div class="secondary-small--bold">Number of Custom Prices</div>
    </div>
  </div>
</div>

<div class="tile">
  <!-- DESKTOP -->
  {#each distributors as distributor}
    <div class="show--md tile__row tile__row--hoverable cursor-pointer">
      <UIRouterLink stateName="layout.pricing_details" params={{ distributorId: distributor.id }}>
        <div class="padding--default" distributor-id={distributor.id}>
          <div class="grid-row">
            <div class="grid-col c6-12">
              <div
                class="s6 ellipsis color-brandPrimary notranslate"
                id="distributor_details_{distributor.id}"
              >
                {distributor.name}
              </div>
            </div>
            <div class="grid-col c6-12 align-right">
              <div class="s6 ellipsis">{distributor.custom_price_counts}</div>
            </div>
          </div>
        </div>
      </UIRouterLink>
    </div>

    <!-- MOBILE -->
    <ul class="list list--vertical list--gutter-none tile__row hide--md">
      <UIRouterLink stateName="layout.pricing_details" params={{ distributorId: distributor.id }}>
        <li class="list-item padding--smaller cursor-pointer">
          <div class="media">
            <div
              class="media-fluid s6 ellipsis color-brandPrimary notranslate"
              id="distributor_details_{distributor.id}"
            >
              {distributor.name}
            </div>
            <Icon width="10" height="10" type="ArrowRight" extraClassNames="margin-top--smallest" />
          </div>
        </li>
      </UIRouterLink>
    </ul>
  {/each}

  {#if distributors.length == 0}
    <div class="margin-top--default margin-bottom--default h3 align-center opacity-50">
      None found.
    </div>
  {/if}
</div>
